module.exports = __webpack_public_path__ + "img/Klaim-Active.58a989e3.svg";